import { Avatar, AvatarGroup, styled } from '@mui/material';
import { GivelifyIcon } from '../icon';
import { DesignTokens } from '../specify';

export const GroupWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px',
    gap: '4px',
}));

export const GroupConfettiIcon = styled(GivelifyIcon)(({ theme }) => ({
    [theme.breakpoints.down('mobile')]: {
        width: '30px',
    },
}));

export const GroupGenerosityIcon = styled(GivelifyIcon)(({ theme }) => ({
    fontSize: '90px',
    [theme.breakpoints.down('mobile')]: {
        fontSize: '68px',
    },
}));

export const HorizontalDivider = styled('div')(({ theme }) => ({
    width: '64px',
    border: `1px dashed ${DesignTokens.color.globalGuidingViolet400}`,
    borderRadius: '15px',

    [theme.breakpoints.down('smallTablet')]: {
        width: '32px',
    },

    [theme.breakpoints.down('mobile')]: {
        width: '16px',
    },
}));

export const StyledAvatarGroup = styled(AvatarGroup)(() => ({
    justifyContent: 'center',
}));

export const StyledAvatar = styled(Avatar, {
    shouldForwardProp: (propName) => propName !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
    width: 80,
    height: 80,

    ...(!compact && {
        [theme.breakpoints.down('mobile')]: {
            width: 48,
            height: 48,
        },
    }),
}));
